// TODO: container vs. component
// TODO: analytics
// TODO: login/logout upon expired token
// TODO: favicon
// TODO: centralizar todas as urls externas no backend (ativação, link solicitação, etc)
// TODO: configurar os testes
// TODO: 'redux-devtools-extension/logOnlyInProduction'
// TODO: "redux-persist": "^5.10.0", -> remover store.subscribe/saveStateToLocalStorage & loadStateFromLocalStorage
// TODO: https://developers.google.com/web/fundamentals/web-app-manifest/?hl=en

import { BlipChat } from 'blip-chat-widget';
import { ConnectedRouter } from 'connected-react-router';
import _ from 'lodash';
import { parse } from 'query-string';
import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';
import { IntlProvider } from 'react-intl';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { compose } from 'redux';
import info from '../../src/commons/services/versaoBackend';
import Loading from '../commons/containers/Loading';
import AppModal from '../commons/containers/Modal';
import PrivateRoute from '../commons/containers/PrivateRoute';
import { getIntlProviderConfig } from '../commons/i18n/intl';
import { ROUTES } from '../commons/routes/routes';
import {
	actions as cfgActions,
	consts as cfgConsts,
	selectors as cfgSelectors,
	types as cfgTypes
} from '../redux/modules/configuracoes';
import { actions as flowActions, selectors as flowSelectors } from '../redux/modules/flow';
import {
	actions as userActions,
	selectors as userSelectors,
	types as userTypes
} from '../redux/modules/usuario';
import AppLayout from './AppLayout/AppLayout';
import {
	computeBubbleShift,
	computeBubbleSide,
	computeChatPanelHeight,
	computeChatPanelPosition
} from './chatPlacement';
import './style.css';
import { withTheme } from 'styled-components';
import Modal from '../commons/components/Modal';

const appContextPath = 'portal-servicos-frontend';

const Manutencao = Loadable({
	loader: () => import('../commons/containers/Manutencao'),
	loading: Loading
});

let bubble;

const CHAT_POSITION_KEY = 'portal-servicos-chat-position';
const CHAT_BUTTON_SIZE = 60;
const CHAT_PANEL_WIDTH = 400;
const CHAT_DRAG_MARGIN = 10;
const CHAT_DRAG_THRESHOLD = 6;
// mesma media query em que o widget Blip assume fullscreen
const CHAT_MOBILE_QUERY = 'screen and (max-width: 480px), screen and (max-height: 420px)';

class App extends Component {
	constructor(props) {
		super(props);

		const parsed = parse(this.props.history.location.search, { decode: true });

		this.state = {
			access_token: parsed.access_token || undefined,
			exibirModal: false,
			textoAviso: '',
			fechouAviso: false
		};

		this.initialize = _.once(function() {
			const { history, analytics, chatBotBlipKey, config } = this.props;
			if (Boolean(analytics)) {
				// inicializando a google analytics
				ReactGA.initialize(analytics);

				// page view da url atual
				ReactGA.pageview(appContextPath + history.location.pathname);

				// ouvindo alterações de url
				history.listen(location => {
					ReactGA.pageview(appContextPath + location.pathname);
				});
			}

			if (chatBotBlipKey && chatBotBlipKey.texto && chatBotBlipKey.texto.length > 1) {
				const blipChat = new BlipChat();
				blipChat
					.withAppKey(chatBotBlipKey.texto)
					.withButton({ color: props.theme.colors.chatColor })
					.withEventHandler(BlipChat.ENTER_EVENT, () => {
						this.hideBubble();
						// reposiciona ao abrir: no mobile solta o container para a tela cheia
						if (this.onChatToggle) {
							this.onChatToggle();
						}
					})
					.withEventHandler(BlipChat.LEAVE_EVENT, () => {
						// reancora o botão na posição escolhida ao fechar
						if (this.onChatToggle) {
							this.onChatToggle();
						}
					})
					.withoutHistory();

				// domínio do tenant na Blip (ex.: https://xxx.chat.blip.ai/); sem ele o widget
				// usa o chat.blip.ai compartilhado, que não carrega mais dentro do iframe
				if (config && config.CHATBOT_BLIP_URL) {
					blipChat.withCustomCommonUrl(config.CHATBOT_BLIP_URL);
				}

				blipChat.build();

				// o header Referrer-Policy: no-referrer do ambiente impede o handshake do chat:
				// o app da Blip só inicia a conversa quando recebe a origem da página que o
				// embeda. Libera o envio da origem apenas no iframe do chat (o iframe é criado
				// pelo widget na primeira abertura, por isso o observer) e recarrega para a
				// navegação repetir já com a nova política.
				const chatContainer = document.getElementById('blip-chat-container');
				if (chatContainer && window.MutationObserver) {
					new MutationObserver(() => {
						const chatIframe = document.getElementById('blip-chat-iframe');
						if (chatIframe && chatIframe.referrerPolicy !== 'strict-origin-when-cross-origin') {
							chatIframe.referrerPolicy = 'strict-origin-when-cross-origin';
							chatIframe.setAttribute('src', chatIframe.getAttribute('src'));
						}
					}).observe(chatContainer, { childList: true, subtree: true });
				}

				this.createBubble(blipChat);
				this.makeChatDraggable();

				setTimeout(() => this.hideBubble(), 10000);
			}
		});
	}

	createBubble(blipChat) {
		const bubbleContainer = document.createElement('div');
		bubbleContainer.id = 'bubble-container';

		bubble = document.createElement('div');
		bubble.id = 'message-bubble';
		bubble.style.backgroundColor = this.props.theme.colors.chatColor;
		bubble.onclick = function() {
			blipChat.widget._openChat();
		};

		var triangle = document.createElement('div');
		triangle.id = 'triangle';
		triangle.style.color = this.props.theme.colors.light;

		var message = document.createElement('div');
		message.id = 'message';
		message.innerHTML = 'Olá, posso ajudar?';

		bubble.appendChild(message);
		bubble.appendChild(triangle);
		bubbleContainer.appendChild(bubble);

		document.querySelector(`#blip-chat-container`).prepend(bubbleContainer);
	}

	makeChatDraggable() {
		const container = document.querySelector('#blip-chat-container');
		const button = document.querySelector('#blip-chat-open-iframe');
		if (!container || !button) {
			return;
		}

		container.classList.add('draggable');

		const isMobile = () => window.matchMedia(CHAT_MOBILE_QUERY).matches;

		// posição = canto inferior direito do botão em relação ao viewport
		const clamp = pos => ({
			x: Math.min(
				Math.max(pos.x, CHAT_BUTTON_SIZE + CHAT_DRAG_MARGIN),
				window.innerWidth - CHAT_DRAG_MARGIN
			),
			y: Math.min(
				Math.max(pos.y, CHAT_BUTTON_SIZE + CHAT_DRAG_MARGIN),
				window.innerHeight - CHAT_DRAG_MARGIN
			)
		});

		// padrão reproduz o right: 35px / bottom: 35px original do widget
		const defaultPosition = () => ({ x: window.innerWidth - 35, y: window.innerHeight - 35 });

		let position = defaultPosition();
		// enquanto o usuário não escolhe uma posição, o botão segue o canto no resize
		let hasCustomPosition = false;
		try {
			const saved = JSON.parse(localStorage.getItem(CHAT_POSITION_KEY));
			if (saved && isFinite(saved.x) && isFinite(saved.y)) {
				position = saved;
				hasCustomPosition = true;
			}
		} catch (error) {
			// posição salva inválida: mantém o padrão
		}

		// o painel (#blip-chat-iframe) só existe após o primeiro clique que abre o chat
		const applyPanelPosition = () => {
			const panel = document.querySelector('#blip-chat-iframe');
			if (!panel) {
				return;
			}
			if (isMobile()) {
				// devolve o posicionamento ao CSS fullscreen do widget
				panel.style.removeProperty('left');
				panel.style.removeProperty('top');
				return;
			}
			const { top, left, flippedDown } = computeChatPanelPosition({
				anchorX: position.x,
				anchorY: position.y,
				viewportWidth: window.innerWidth,
				viewportHeight: window.innerHeight,
				panelWidth: CHAT_PANEL_WIDTH,
				panelHeight: computeChatPanelHeight({ viewportOuterHeight: window.outerHeight })
			});
			panel.style.left = `${left - position.x}px`;
			panel.style.top = `${top - position.y}px`;
			if (flippedDown) {
				container.classList.add('panel-below');
			} else {
				container.classList.remove('panel-below');
			}
		};

		const applyBubblePlacement = () => {
			const bubbleContainer = document.querySelector('#bubble-container');
			if (!bubbleContainer) {
				return;
			}
			bubbleContainer.style.removeProperty('transform');
			const side = computeBubbleSide({ anchorX: position.x, viewportWidth: window.innerWidth });
			if (side === 'right') {
				container.classList.add('bubble-right');
			} else {
				container.classList.remove('bubble-right');
			}
			if (!bubbleContainer.offsetWidth) {
				return;
			}
			const rect = bubbleContainer.getBoundingClientRect();
			const shift = computeBubbleShift({
				bubbleLeft: rect.left,
				bubbleRight: rect.right,
				viewportWidth: window.innerWidth
			});
			if (shift) {
				bubbleContainer.style.transform = `translateX(${shift}px)`;
			}
		};

		const isChatOpen = () => button.classList.contains('opened');

		const applyPosition = () => {
			if (isMobile() && isChatOpen()) {
				// chat aberto no mobile é tela cheia: devolve o container ao CSS do widget
				['position', 'left', 'top', 'right', 'bottom', 'height'].forEach(prop =>
					container.style.removeProperty(prop)
				);
				applyPanelPosition();
				return;
			}
			position = clamp(position);
			// position e height inline neutralizam o CSS mobile do widget (absolute, height 100%)
			container.style.position = 'fixed';
			container.style.left = `${position.x}px`;
			container.style.top = `${position.y}px`;
			container.style.right = 'auto';
			container.style.bottom = 'auto';
			container.style.height = '0';
			applyPanelPosition();
			applyBubblePlacement();
		};

		applyPosition();
		window.addEventListener('resize', () => {
			if (!hasCustomPosition) {
				position = defaultPosition();
			}
			applyPosition();
		});

		// abrir (botão ou bolha) e fechar reavaliam tudo; o painel só existe após a primeira abertura
		this.onChatToggle = applyPosition;

		let dragStart = null;
		let dragged = false;

		button.addEventListener('dragstart', event => event.preventDefault());

		button.addEventListener('pointerdown', event => {
			if (!event.isPrimary) {
				return;
			}
			dragged = false;
			dragStart = { pointerX: event.clientX, pointerY: event.clientY, x: position.x, y: position.y };
			button.setPointerCapture(event.pointerId);
		});

		button.addEventListener('pointermove', event => {
			if (!dragStart) {
				return;
			}
			const dx = event.clientX - dragStart.pointerX;
			const dy = event.clientY - dragStart.pointerY;
			if (!dragged && Math.abs(dx) + Math.abs(dy) < CHAT_DRAG_THRESHOLD) {
				return;
			}
			dragged = true;
			position = { x: dragStart.x + dx, y: dragStart.y + dy };
			applyPosition();
		});

		const endDrag = () => {
			if (!dragStart) {
				return;
			}
			dragStart = null;
			if (dragged) {
				hasCustomPosition = true;
				localStorage.setItem(CHAT_POSITION_KEY, JSON.stringify(position));
			}
		};
		button.addEventListener('pointerup', endDrag);
		button.addEventListener('pointercancel', endDrag);

		// suprime o click disparado ao soltar o arrasto, senão o widget abre o chat
		container.addEventListener(
			'click',
			event => {
				if (dragged) {
					dragged = false;
					event.preventDefault();
					event.stopPropagation();
				}
			},
			true
		);
	}

	displayBubble() {
		bubble.style.display = '';
	}

	hideBubble() {
		bubble.style.display = 'none';
	}

	shouldLogin() {
		return !this.props.isAuthenticated && this.state.access_token;
	}

	isHTML(str) {
		var a = document.createElement('div');
		a.innerHTML = str;

		for (var c = a.childNodes, i = c.length; i--; ) {
			if (c[i].nodeType === 1) return true;
		}

		return false;
	}

	isExibirModalAviso(mensagemTelaInicial) {
		return (
			mensagemTelaInicial &&
			mensagemTelaInicial.texto &&
			!this.state.exibirModal &&
			!this.state.fechouAviso
		);
	}

	componentWillUnmount() {
		if (this.shouldLogin()) {
			this.props.reset(userTypes.USER_LOGIN);
		}

		this.props.reset(cfgTypes.FIND);
	}

	async componentDidMount() {
		console.log('Portal Serviços Frotend', process.env.REACT_APP_VERSION);
		if (this.shouldLogin()) {
			this.props.forceLogin({ access_token: this.state.access_token });
		}
		try {
			const { version } = await info.consultarInfoBackend();
			console.log('Portal Serviços Backend', 'Version', version);
		} catch (error) {
			console.error('Erro ao consultar a versão do backend', error);
		}

		this.props.carregarConfiguracoesIniciais();
	}

	renderRoutes(stantalone) {
		return _.chain(ROUTES)
			.map(route => route)
			.filter(route => Boolean(route.isStandalone) === stantalone)
			.map((route, i) => {
				return route.isPrivate ? <PrivateRoute key={i} {...route} /> : <Route key={i} {...route} />;
			})
			.value();
	}

	render() {
		const {
			doneCfgs,
			loadingCfgs,
			sucessoCfgs,
			messages,
			history,
			mensagemTelaInicial
		} = this.props;

		if (loadingCfgs || !doneCfgs || (this.shouldLogin() && !this.props.doneLogin)) {
			// configurações e login ainda não carregaram...
			return <Loading />;
		}

		if (this.isExibirModalAviso(mensagemTelaInicial)) {
			this.setState({ exibirModal: true, textoAviso: mensagemTelaInicial.texto });
		}

		if (!sucessoCfgs) {
			return <Manutencao />;
		}

		this.initialize();
		const intlProviderProps = getIntlProviderConfig(messages);

		return (
			<IntlProvider {...intlProviderProps}>
				<ConnectedRouter history={history}>
					<Fragment>
						<Route component={AppModal} />
						<Switch>
							{this.renderRoutes(true)}
							<Switch>
								<AppLayout>
									<Switch>{this.renderRoutes(false)}</Switch>
								</AppLayout>
							</Switch>
						</Switch>
						<Modal
							size="lg"
							open={this.state.exibirModal}
							onClose={() => {
								this.setState({ exibirModal: false, fechouAviso: true });
							}}>
							{this.isHTML(this.state.textoAviso) ? (
								<div
									dangerouslySetInnerHTML={{
										__html: `${this.state.textoAviso}`
									}}
								/>
							) : (
								<p>{this.state.textoAviso}</p>
							)}
						</Modal>
					</Fragment>
				</ConnectedRouter>
			</IntlProvider>
		);
	}
}

function mapStateToProps(state) {
	return {
		loadingCfgs: flowSelectors.isLoadingByType(state, cfgTypes.CARREGAR_CONFIGURACOES_INICIAIS),
		doneCfgs: flowSelectors.isDoneByType(state, cfgTypes.CARREGAR_CONFIGURACOES_INICIAIS),
		erroCfgs: flowSelectors.getErrorByType(state, cfgTypes.CARREGAR_CONFIGURACOES_INICIAIS),
		sucessoCfgs: flowSelectors.isSuccessByType(state, cfgTypes.CARREGAR_CONFIGURACOES_INICIAIS),
		doneLogin: flowSelectors.isDoneByType(state, userTypes.USER_LOGIN),
		isAuthenticated: userSelectors.isAuthenticated(state),
		messages: cfgSelectors.getValorConfiguracao(state, cfgConsts.APPLICATION_FRONTEND_RESOURCES),
		analytics: cfgSelectors.getValorConfiguracao(state, cfgConsts.GOOGLE_ANALYTICS_KEY),
		chatBotBlipKey: cfgSelectors.getConfiguracao(state, cfgConsts.CHATBOT_BLIP_KEY),
		config: cfgSelectors.getValorConfiguracao(state, cfgConsts.APPLICATION_CONFIG_RESOURCES),
		mensagemTelaInicial: cfgSelectors.getConfiguracao(state, cfgConsts.MENSAGEM_AVISO_TELA_INICIAL),
		state: state
	};
}

const mapDispatchToProps = {
	carregarConfiguracoesIniciais: cfgActions.carregarConfiguracoesIniciais,
	reset: flowActions.reset,
	forceLogin: userActions.forceLoginUser
};

export default compose(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)
)(withTheme(App));
